//
// GTM event tracking
//

import { onCategoryBannerClick } from './category-banner'
;(($) => {
    $(() => {
        const blueprintButton = $('#view-drawing-button')
        let isVisible = false
        blueprintButton.click(() => {
            isVisible = !isVisible
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'download_content',
                    content_type: 'blueprint',
                    product_name: document.getElementsByClassName('npp__title--heading1')[0].innerText,
                })
            }
        })

        $('.shopping-cart-wrapper')
            .find('.item-remove a')
            .click(function () {
                if (window.dataLayer) {
                    let itemRow = $(this).parents('.cart-item-row')
                    window.dataLayer.push({
                        event: 'remove_from_cart',
                        ecommerce: {
                            currency: itemRow.attr('data-currencyCode'),
                            items: [
                                {
                                  item_id: itemRow.attr('data-item-id'),
                                  item_name: itemRow.attr('data-item-name'),
                                  price: itemRow.attr('data-item-price'),
                                  quantity: parseInt(itemRow.attr('data-item-quantity'), 10),
                                  item_category: itemRow.attr('data-item-category') || ''
                                }
                            ]
                        },
                    })
                }
            })

        const globalMessageLink = $('.global-message').find('a')
        if (globalMessageLink) {
            globalMessageLink.click(function (e) {
                onCategoryBannerClick(e, 'sticky')
            })
        }
    })
})(jQuery)
